import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, NavigationStart, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';
import { UsersService } from '../services/users.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  public active: boolean = false;
  public activeSection: any = 'home';
  public cartLength = 0;
  public userDetails$: Observable<any>;
  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    public authService: AuthService,
    public userService: UsersService) {
    router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        if (event.url.includes('courses')) {
          this.activeSection = event.url.includes('admin') ? 'course-wizard' : 'courses';
        } else {
          this.activeSection = event.url.split('/').slice(-1)[0];
        }
      }
    })

  }

  ngOnInit(): void {
    let userId = JSON.parse(sessionStorage.getItem('logged-in-user'))?._id;
    if (userId)
      this.userDetails$ = this.userService.getUserDetails(userId);
    if (JSON.parse(sessionStorage.getItem('activeSection'))) {
      this.activeSection = JSON.parse(sessionStorage.getItem('activeSection'));
    }
    else {
      this.activeSection = 'home';
      sessionStorage.setItem('activeSection', JSON.stringify(this.activeSection))
    }
  }

  onClickMenuBar() {
    this.active = !this.active;
  }

  onClickMenu(section: string) {
    let userId = JSON.parse(sessionStorage.getItem('logged-in-user'))?._id;
    if (section == 'dashboard') {
      this.router.navigate([`student/${userId}/dashboard`]);
    }
    this.activeSection = section;
    sessionStorage.setItem('activeSection', JSON.stringify(this.activeSection));
    if (this.active)
      this.active = false;
  }

  onClickLogo() {
    this.router.navigate(['home']);
    this.activeSection = 'home';
    sessionStorage.setItem('activeSection', JSON.stringify(this.activeSection))
  }

  onClickCart() {
    this.router.navigate(['1234/cart']);
  }

  onClickLogin() {
    this.router.navigate(['login']);
    this.activeSection = 'login';
    sessionStorage.setItem('activeSection', JSON.stringify(this.activeSection));
    if (this.active)
      this.active = false;
  }

  onClickLogout() {
    this.authService.logout().subscribe(() => {
      this.authService.loggedIn = false;
      this.authService.isAdmin = false;
      sessionStorage.removeItem('logged-in-user');
      this.onClickLogin();
    })
  }

}
